var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('H4',[_vm._v("Notifications VIEW FOR SENIOR! NEEDS WORK!!!")]),_c('b-card',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Escalations"}},[_vm._v("Tab1")]),_c('b-tab',{attrs:{"title":"High Priority"}},[_vm._v("Tab2")]),_c('b-tab',{attrs:{"title":"Medium Priority"}},[_vm._v("Tab3")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }